// Single source of truth (frontend side) for the configurable value-field visibility feature.
// Field keys use the backend DTO property names (PascalCase); form field names derive from them
// by lower-casing the first letter (same convention as fieldsUpdatedByExternalUser).

export const TOGGLEABLE_VALUE_FIELDS = [
  "BuildingValues",
  "EquipmentValues",
  "StockValues",
  "BusinessInteruptionValues12Months",
  "IndemnityPeriodCode",
] as const;

export type ValueFieldKey = (typeof TOGGLEABLE_VALUE_FIELDS)[number];

export const toFormFieldName = (fieldKey: string) =>
  fieldKey.charAt(0).toLowerCase() + fieldKey.slice(1);

export interface IValueFieldsVisibilityInfo {
  enabledFields: string[];
  visibleFields: string[];
  isDefault: boolean;
  sourceClientId?: number | null;
  sourceLocationId?: number | null;
  sourceConfigurationSettingId?: number | null;
}

export const ALL_FIELDS_VISIBLE: IValueFieldsVisibilityInfo = {
  enabledFields: [...TOGGLEABLE_VALUE_FIELDS],
  visibleFields: [],
  isDefault: true,
};

// Returns true when the given form field (camelCase) should be rendered for the effective visibility.
// Fields that are not controlled by the configuration are always visible.
export const isFormFieldVisible = (
  visibility: IValueFieldsVisibilityInfo | null | undefined,
  formFieldName: string
) => {
  if (!visibility || visibility.isDefault) return true;
  const controlled = new Set(
    [
      ...TOGGLEABLE_VALUE_FIELDS,
      "BuildingValuesComment",
      "EquipmentValuesComment",
      "StockValuesComment",
      "BusinessInteruptionValues12MonthsComment",
      "TotalPd",
      "TotalPdBi",
      "BusinessInteruptionValuesBasedOnIndemnityPeriod",
      "TotalPdBiBasedOnIndemnityPeriod",
    ].map(toFormFieldName)
  );
  if (!controlled.has(formFieldName)) return true;
  return visibility.visibleFields.map(toFormFieldName).includes(formFieldName);
};
